import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import IntroductionForm from './introduction/IntroductionForm';
import IntroductionHistory from './introduction/IntroductionHistory';
import EligibilityProgress from './EligibilityProgress';
import logger from '../utils/logger';

const PrivateIntroduction = ({ user }) => {
  const [eligibility, setEligibility] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ full_name: '', email: '', relationship: '', note: '' });
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [historyRefresh, setHistoryRefresh] = useState(0);
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => { checkEligibility(); }, []);
  const checkEligibility = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${API_URL}/api/users/introduction-eligibility-status`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      setEligibility(await response.json());
    } catch (err) { logger.error('Error checking eligibility:', err); }
    finally { setLoading(false); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess(''); setSending(true);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${API_URL}/api/users/introductions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || 'Failed to send introduction');
      setSuccess('Introduction sent successfully!');
      setFormData({ full_name: '', email: '', relationship: '', note: '' });
      checkEligibility();
      setHistoryRefresh((n) => n + 1);
    } catch (err) { setError(err.message); }
    finally { setSending(false); }
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  if (loading) return <div className="flex items-center justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-emerald-600" /></div>;
  if (!eligibility?.eligible) return null;

  return (
    <div className="space-y-6">
      <div>
        <p className="text-slate-600">MyInvestFolio is available mainly by private introductions. Use this to privately introduce trusted individuals.</p>
        <p className="text-slate-600 mt-2">Each request is reviewed independently.</p>
        <p className="text-slate-600 mt-2">No information about you, them or any investments will be shared.</p>
      </div>
      <EligibilityProgress eligibilityData={eligibility} />
      {eligibility?.eligible && (
        <IntroductionForm formData={formData} handleChange={handleChange} handleSubmit={handleSubmit}
          sending={sending} error={error} success={success} eligibility={eligibility} />
      )}
      <IntroductionHistory refreshToken={historyRefresh} />
    </div>
  );
};

export default PrivateIntroduction;
